import React from 'react'
import './HowItWorks.css'
import { images } from '../../assets'

function HowItWorks() {
  return (
    <div className='howItWorks'>
        <div className='howItWorksContent'>
            <div className='howItWorksHeading'>How it works?</div>
            <div className='csrSteps'>
                <div className='howWorkStep'>
                    <img src={images.downloadIcon} alt='downloadIcon' />
                    <div className='csrStepsText'>Users donate their steps</div>
                </div>
                <div className='howWorkStep companyCsr'>
                    <img src={images.donateIcon} alt='donateIcon' />
                    <div className='csrStepsText'>Companies match with CSR</div>
                </div>
                <div className='howWorkStep'>
                    <img src={images.rewardIcon} alt='rewardIcon' />
                    <div className='csrStepsText'>Non-Profits get funds</div>
                </div>
            </div>
        </div>
      
    </div>
  )
}

export default HowItWorks
